import type { SectionIcon } from './types'

export const areasIcons: SectionIcon[] = [
  {
    identifier: 'parking',
    icon: 'parking',
  },
  {
    identifier: 'massage_room',
    icon: 'massage',
  },
  {
    identifier: 'courtyard',
    icon: 'patio',
  },
  {
    identifier: 'cigar_cellar',
    icon: 'cigare',
  },
  {
    identifier: 'smokehouse',
    icon: 'smokingRoom',
  },
  {
    identifier: 'restroom',
    icon: 'toilette',
  },
  {
    identifier: 'pool_house',
    icon: 'poolHouse',
  },
  {
    identifier: 'garden',
    icon: 'garden',
  },
  {
    identifier: 'living_room',
    icon: 'livingRoom',
  },
  {
    identifier: 'spa',
    icon: 'spa',
  },
  {
    identifier: 'terrace',
    icon: 'terrace',
  },
  {
    identifier: 'badminton_court',
    icon: 'badminton',
  },
  {
    identifier: 'basketball_court',
    icon: 'basketball',
  },
  {
    identifier: 'football_field',
    icon: 'football',
  },
  {
    identifier: 'petanque',
    icon: 'petanque',
  },
  {
    identifier: 'tennis_court',
    icon: 'tennis',
  },
  {
    identifier: 'volleyball_court',
    icon: 'volley',
  },
  {
    identifier: 'pool_area',
    icon: 'swimmingPool',
  },
  {
    identifier: 'padel_court',
    icon: 'padel',
  },
  {
    identifier: 'bar',
    icon: 'cocktail',
  },
  {
    identifier: 'laundry_room',
    icon: 'buanderie',
  },
  {
    identifier: 'adults_bedroom',
    icon: 'bed',
  },
  {
    identifier: 'office_room',
    icon: 'bureau',
  },
  {
    identifier: 'dormitory',
    icon: 'bunkBed',
  },
  {
    identifier: 'kitchen',
    icon: 'kitchen',
  },
  {
    identifier: 'dressing_room',
    icon: 'dressing',
  },
  {
    identifier: 'ski_room',
    icon: 'ski',
  },
  {
    identifier: 'rooftop',
    icon: 'rooftop',
  },
  {
    identifier: 'dining_room',
    icon: 'diningRoom',
  },
  {
    identifier: 'bathroom',
    icon: 'bath',
  },
  {
    identifier: 'billiard_room',
    icon: 'pool',
  },
  {
    identifier: 'movie_room',
    icon: 'popcorn',
  },
  {
    identifier: 'conference_room',
    icon: 'conference',
  },
  {
    identifier: 'game_room',
    icon: 'children',
  },
  {
    identifier: 'meditation_room',
    icon: 'meditation',
  },
  {
    identifier: 'music_room',
    icon: 'guitar',
  },
  {
    identifier: 'fitness_room',
    icon: 'trainingBike',
  },
  {
    identifier: 'tv_room',
    icon: 'tv',
  },
  {
    identifier: 'veranda',
    icon: 'veranda',
  },
  {
    identifier: 'children_bedroom',
    icon: 'twinBed',
  },
]
